module.exports = __webpack_public_path__ + "static/media/Learning.6b9f5d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Assurant/Learning.png
// module id = 123
// module chunks = 0